module.exports = __webpack_public_path__ + "static/media/highly-customizable.8693ab71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/serviceicon2/highly-customizable.svg
// module id = 434
// module chunks = 0